import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isSameDay } from 'date-fns';

import { format } from '../utils';
import Notification from '../BaseComponents/Notification';

interface Props {
	variant: 'normal' | 'outlined';
	date: Date;
	orderIsBooked?: boolean;
	orderId: string;
	onCancelOrder?: () => void;
	className?: string;
}

const PaymentTimeLimit: React.FunctionComponent<Props> = props => {
	const { t } = useTranslation('PaymentTimeLimit');
	const isToday = isSameDay(props.date, new Date());

	const messageText = React.useMemo(() => {
		let message = props.orderIsBooked ? t('Booking must be paid') : t('Booking must be completed');

		message += isToday
			? ` ${t('today before')} ${format(props.date, 'HH:mm')}`
			: ` ${t('before')} ${format(props.date, 'dd MMMM, HH:mm')}`;

		return message;
	}, [isToday, props.date]);

	return (
		<Notification
			type="context"
			status="warning"
			text={messageText}
			className={props.className}
			actionText={props.orderIsBooked && props.onCancelOrder && t('Cancel order')}
			onClickAction={props.onCancelOrder ? props.onCancelOrder : null}
		/>
	);
};

export default PaymentTimeLimit;
